import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { TelegramGroup } from "@/lib/types";

async function fetchGroups(): Promise<TelegramGroup[]> {
  const { data, error } = await supabase
    .from("telegram_groups")
    .select("*")
    .order("created_at", { ascending: false });

  if (error) throw error;
  return (data ?? []) as TelegramGroup[];
}

export function useGroups() {
  return useQuery<TelegramGroup[], Error>({
    queryKey: ["telegram-groups"],
    queryFn: fetchGroups,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
